import { AsyncPipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LombardFacade } from '@zero/lombard/domain';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { filter } from 'rxjs';
import { LombardCancelModalComponent } from '../lombard-cancel-modal/lombard-cancel-modal.component';
import { LombardConfirmationModalComponent } from '../lombard-confirmation-modal/lombard-confirmation-modal.component';
import { LombardConfirmationReminderComponent } from '../lombard-confirmation-reminder/lombard-confirmation-reminder.component';
import { LombardEditModalComponent } from '../lombard-edit-modal/lombard-edit-modal.component';
import { LombardFaqsComponent } from '../lombard-faqs/lombard-faqs.component';

@Component({
  selector: 'lombard-status',
  templateUrl: './lombard-status.component.html',
  styleUrls: ['./lombard-status.component.scss'],
  imports: [
    TranslocoPipe,
    LombardFaqsComponent,
    LombardConfirmationReminderComponent,
    AsyncPipe,
    DecimalPipe,
    NgClass,
    ButtonComponent,
    ModalComponent,
  ],
})
export class LombardStatusComponent implements OnInit {
  public readonly facade = inject(LombardFacade);
  public readonly modal = inject(NgbModal);
  readonly #destroyRef = inject(DestroyRef);
  readonly #modalOptions: NgbModalOptions = { size: 'lg' };

  ngOnInit(): void {
    this.facade.shouldDisplayConfirmationModal$
      .pipe(
        filter((isReadyToConfirm) => isReadyToConfirm),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(this.confirmCredit);
  }

  public cancelCredit = (): NgbModalRef => this.modal.open(LombardCancelModalComponent, this.#modalOptions);
  public confirmCredit = (): NgbModalRef => this.modal.open(LombardConfirmationModalComponent, this.#modalOptions);
  public editCredit = (): NgbModalRef => this.modal.open(LombardEditModalComponent, this.#modalOptions);
}
